module.exports = __webpack_public_path__ + "img/8acb63119f2a4d3da1b3f135078edb09.cc6b4e45.png";